<template>
  <div class="flex flex-col overflow-visible">
    <div class="text-lg leading-7 font-bold">
      {{ $t('quote.select-four-preferred-times') }}
    </div>
    <div class="grid gap-y-4 mt-4 lg:mt-8">
      <vetster-inquiry-timeslot-picker
        v-for="index in 4"
        :key="index"
        :index="index"
        :disabled-dates="disabledDates"
        @update="(timeslot) => setTimeslot(index, timeslot)"
      />
    </div>
    <div class="grid mt-6 lg:mt-8 gap-x-2">
      <vetster-button
        variant="bubblegum"
        class="w-full"
        @click="$emit('submit', getPayload())"
      >
        <span>{{ $t('quote.confirm-times') }}</span>
      </vetster-button>
      <vetster-button
        variant="textLink"
        class="underline text-sm"
        @click="$emit('cancel')"
      >
        <span>{{ $t('app.cancel') }}</span>
      </vetster-button>
    </div>
  </div>
</template>

<script>
import clone from 'lodash/clone';
import map from 'lodash/map';
import padStart from 'lodash/padStart';
import { DateTime } from 'luxon';
import { mapState } from 'vuex';

import VetsterInquiryTimeslotPicker from '@/brand-components/VetsterInquiryTimeslotPicker';

export default {
  name: 'VetsterInquiryTimeslotStep',

  components: { VetsterInquiryTimeslotPicker },

  data() {
    return {
      timeslots: [],
    };
  },

  computed: {
    ...mapState('search', ['inputs']),

    disabledDates() {
      return map(this.timeslots, 'date_from');
    },
  },

  methods: {
    getPayload() {
      const timezone = this.inputs.timezone ?? DateTime.local().zoneName;

      return this.timeslots.map((timeslot) => ({
        start_at: DateTime.fromFormat(
          `${timeslot.date_from} ${timeslot.time_from}`,
          'y-MM-dd T',
        )
          .setZone(timezone, { keepLocalTime: true })
          .setZone('UTC').toISO({ suppressMilliseconds: true }),
        end_at: DateTime.fromFormat(
          `${timeslot.date_from} ${timeslot.time_to}`,
          'y-MM-dd T',
        )
          .setZone(timezone, { keepLocalTime: true })
          .setZone('UTC').toISO({ suppressMilliseconds: true }),
      }));
    },
    setTimeslot(index, item) {
      const timeslot = clone(item);

      if (timeslot.time_from !== null) {
        timeslot.time_from = this.timeAsString(timeslot.time_from);
      }

      if (timeslot.time_to !== null) {
        timeslot.time_to = this.timeAsString(timeslot.time_to);
      }

      this.$set(this.timeslots, index - 1, timeslot);
    },
    timeAsString(value) {
      const timeString = padStart(value || 0, 4, '0');

      return `${timeString.substring(0, 2)}:${timeString.substring(2, 4)}`;
    },
  },
};
</script>
